/* eslint-disable max-lines */
export interface IIconMap {
  [key: string]: string;
}

export const iconsByClass: IIconMap = {
  AccessKey: 'brand/jupiterone/class/AccessKey',
  AccessPolicy: 'brand/jupiterone/class/AccessPolicy',
  AccessRole: 'feather/bookmark',
  Account: 'feather/pocket',
  AdminUser: 'brand/jupiterone/class/AdminUser',
  Application: 'feather/box',
  ApplicationEndpoint: 'brand/jupiterone/class/ApplicationEndpoint',
  AppInstance: 'feather/copy',
  AppInterface: 'feather/code',
  Assessment: 'brand/jupiterone/radar',
  Attacker: 'feather/meh',
  Backup: 'brand/jupiterone/clock-rewind',
  Certificate: 'feather/award',
  Channel: 'feather/hash',
  Change: 'feather/crosshair',
  Cluster: 'feather/server',
  CodeCommit: 'feather/git-commit',
  CodeDeploy: 'brand/jupiterone/class/CodeDeploy',
  CodeMerge: 'feather/git-merge',
  CodeModule: 'feather/package',
  CodeRepo: 'feather/code',
  CodeReview: 'brand/jupiterone/class/CodeReview',
  Configuration: 'feather/layout',
  Container: 'brand/jupiterone/class/Container',
  Control: 'feather/sliders',
  ControlPolicy: 'brand/jupiterone/class/ControlPolicy',
  Computer: 'brand/jupiterone/class/Computer',
  CryptoKey: 'brand/jupiterone/class/CryptoKey',
  Database: 'feather/database',
  DataObject: 'feather/disc',
  DataStore: 'feather/archive',
  Deployment: 'brand/jupiterone/class/CodeDeploy',
  Device: 'feather/tablet',
  Directory: 'feather/book',
  Disk: 'feather/hard-drive',
  Document: 'feather/file',
  Domain: 'brand/jupiterone/class/Domain',
  DomainRecord: 'brand/jupiterone/class/DomainRecord',
  DomainZone: 'brand/jupiterone/class/DomainZone',
  Finding: 'feather/flag',
  Firewall: 'feather/shield',
  Framework: 'feather/map',
  Function: 'brand/jupiterone/class/Function',
  Gateway: 'feather/shuffle',
  Group: 'feather/square',
  Host: 'brand/jupiterone/class/Host',
  HostAgent: 'brand/jupiterone/class/HostAgent',
  Image: 'feather/cpu',
  Incident: 'feather/alert-triangle',
  Interface: 'feather/link-2',
  Internet: 'feather/globe',
  IpAddress: 'feather/navigation-2',
  Key: 'brand/jupiterone/class/Key',
  Logs: 'feather/voicemail',
  Module: 'feather/package',
  Monitor: 'feather/triangle',
  Network: 'feather/share-2',
  NetworkEndpoint: 'brand/jupiterone/class/NetworkEndpoint',
  NetworkInterface: 'feather/link-2',
  Organization: 'brand/jupiterone/class/Organization',
  PasswordPolicy: 'brand/jupiterone/class/PasswordPolicy',
  Person: 'feather/user',
  Policy: 'feather/file-text',
  PR: 'feather/git-pull-request',
  Procedure: 'brand/jupiterone/class/Procedure',
  Product: 'feather/shopping-bag',
  Program: 'feather/umbrella',
  Project: 'feather/folder',
  Proxy: 'feather/shuffle',
  Process: 'feather/loader',
  Queue: 'feather/fast-forward',
  Record: 'feather/file',
  Repository: 'brand/jupiterone/class/Repository',
  Requirement: 'feather/list',
  Resource: 'feather/battery',
  ResourceGroup: 'brand/jupiterone/class/ResourceGroup',
  Review: 'feather/thumbs-up',
  Risk: 'feather/alert-octagon',
  Role: 'feather/award',
  Root: 'brand/jupiterone/class/Root',
  Rule: 'feather/check-circle',
  Ruleset: 'brand/jupiterone/class/Ruleset',
  Scanner: 'feather/life-buoy',
  Secret: 'brand/jupiterone/class/Secret',
  Service: 'feather/cloud',
  Site: 'feather/map-pin',
  Subscription: 'feather/rss',
  Task: 'feather/clock',
  Team: 'feather/users',
  Training: 'brand/jupiterone/class/Training',
  User: 'feather/user',
  UserGroup: 'brand/jupiterone/class/UserGroup',
  Vendor: 'feather/briefcase',
  Vulnerability: 'feather/shield-off',
  Weakness: 'brand/jupiterone/class/Weakness',
  Workload: 'feather/truck',
  Zone: 'feather/target',
};

export const iconsByType: IIconMap = {
  // icons for generic/global types
  employee: 'feather/user',
  internet: 'feather/globe',
  mobile_device: 'feather/smartphone',
  user_endpoint: 'feather/monitor',
  mfa_device: 'aws/security/MFAToken',

  // icons for AWS services
  aws: 'brand/aws/logo',
  aws_account: 'aws/compute/AWSCloud',
  aws_acm: 'aws/logo/ACM',
  aws_apigateway: 'aws/logo/APIGateway',
  aws_appstream: 'aws/logo/AppStream',
  aws_athena: 'aws/logo/Athena',
  aws_applicationautoscaling: 'aws/compute/AutoScaling',
  aws_autoscaling: 'aws/compute/AutoScaling',
  aws_batch: 'aws/logo/Batch',
  aws_chime: 'aws/logo/Chime',
  aws_clouddirectory: 'aws/logo/CloudDirectory',
  aws_cloudformation: 'aws/logo/CloudFormation',
  aws_cloudfront: 'aws/logo/CloudFront',
  aws_cloudhsm: 'aws/logo/CloudHSM',
  aws_cloudsearch: 'aws/logo/CloudSearch',
  aws_cloudtrail: 'aws/logo/CloudTrail',
  aws_cloudwatch: 'aws/logo/CloudWatch',
  aws_codebuild: 'aws/logo/CodeBuild',
  aws_codecommit: 'aws/logo/CodeCommit',
  aws_codedeploy: 'aws/logo/CodeDeploy',
  aws_codepipeline: 'aws/logo/CodePipeline',
  aws_codestar: 'aws/logo/CodeStar',
  aws_cognitoidentity: 'aws/logo/Cognito',
  aws_cognitoidp: 'aws/logo/Cognito',
  aws_config: 'aws/logo/Config',
  aws_connect: 'aws/logo/Connect',
  aws_datapipeline: 'aws/logo/DataPipeline',
  aws_devicefarm: 'aws/logo/DeviceFarm',
  aws_directconnect: 'aws/logo/DirectConnect',
  aws_directoryservice: 'aws/logo/DirectoryService',
  aws_dynamodb: 'aws/logo/DynamoDB',
  aws_dynamodbstreams: 'aws/logo/DynamoDB',
  aws_dms: 'aws/logo/DMS',
  aws_ec2: 'aws/logo/EC2',
  aws_ec2_vpc: 'aws/logo/VPC',
  aws_ecr: 'aws/compute/ECR',
  aws_ecs: 'aws/logo/ECS',
  aws_elasticfilesystem: 'aws/logo/EFS',
  aws_elasticloadbalancing: 'aws/logo/ELB',
  aws_elasticmapreduce: 'aws/logo/EMR',
  aws_es: 'aws/logo/ES',
  aws_elasticbeanstalk: 'aws/logo/ElasticBeanstalk',
  aws_elasticache: 'aws/logo/ElasticCache',
  aws_elastictranscoder: 'aws/logo/ElasticTranscoder',
  aws_firehose: 'aws/compute/KinesisFirehose',
  aws_gamelift: 'aws/logo/GameList',
  aws_glacier: 'aws/logo/Glacier',
  aws_glue: 'aws/logo/Glue',
  aws_greengrass: 'aws/logo/Greengrass',
  aws_iam: 'aws/logo/IAM',
  aws_inspector: 'aws/logo/Inspector',
  aws_iot: 'aws/logo/IoT',
  aws_kms: 'aws/logo/KMS',
  aws_kinesis: 'aws/logo/Kinesis',
  aws_kinesisanalytics: 'aws/logo/Kinesis',
  aws_lambda: 'aws/logo/Lambda',
  aws_lex: 'aws/logo/Lex',
  aws_lightsail: 'aws/logo/Lightsail',
  aws_machinelearning: 'aws/logo/MachineLearning',
  aws_macie: 'aws/logo/Macie',
  aws_managedservices: 'aws/logo/ManagedServices',
  aws_mechanicalturk: 'aws/logo/MechanicalTurk',
  aws_migrationhub: 'aws/logo/MigrationHub',
  aws_mobileanalytics: 'aws/logo/MobileAnalytics',
  aws_mobilehub: 'aws/logo/MobileHub',
  aws_opsworks: 'aws/logo/OpsWorks',
  aws_organizations: 'aws/logo/Organizations',
  aws_pinpoint: 'aws/logo/Pinpoint',
  aws_polly: 'aws/logo/Polly',
  aws_quicksight: 'aws/logo/QuickSight',
  aws_rds: 'aws/logo/RDS',
  aws_redshift: 'aws/logo/Redshift',
  aws_rekognition: 'aws/logo/Rekognition',
  aws_route53: 'aws/logo/Route53',
  aws_s3: 'aws/logo/S3',
  aws_ses: 'aws/logo/SES',
  aws_sms: 'aws/logo/SMS',
  aws_sns: 'aws/logo/SNS',
  aws_sqs: 'aws/logo/SQS',
  aws_swf: 'aws/logo/SWF',
  aws_servicecatalog: 'aws/logo/ServiceCatalog',
  aws_shield: 'aws/logo/Shield',
  aws_snowball: 'aws/logo/Snowball',
  aws_stepfunctions: 'aws/logo/StepFunctions',
  aws_storagegateway: 'aws/logo/StorageGateway',
  aws_support: 'aws/logo/AWS',
  aws_systemsmanager: 'aws/logo/SystemsManager',
  aws_trustedadvisor: 'aws/logo/TrustedAdvisor',
  aws_waf: 'aws/logo/WAF',
  aws_workdocs: 'aws/work/Docs',
  aws_workmail: 'aws/work/Mail',
  aws_workspaces: 'aws/work/Spaces',
  aws_xray: 'aws/logo/XRay',

  // icons for AWS resources/entities
  aws_acm_certificate: 'aws/security/ACM',
  aws_api_gateway_rest_api: 'aws/compute/LoadBalancer',
  aws_cloudformation_stack: 'aws/manage/Stack',
  aws_cloudfront_distribution: 'aws/manage/Deployments',
  aws_cloudwatch_event_rule: 'aws/manage/EventTimeBased',
  aws_dynamodb_table: 'aws/db/Table',
  aws_ami: 'aws/compute/AMI',
  aws_instance: 'aws/compute/Instance',
  aws_internet_gateway: 'aws/compute/InternetGateway',
  aws_network_acl: 'aws/compute/AccessControlList',
  aws_security_group: 'aws/compute/Endpoints',
  aws_subnet: 'aws/compute/VPCSubnet',
  aws_ebs_volume: 'aws/storage/Volume',
  aws_vpc: 'aws/compute/VPC',
  aws_ecr_repository: 'aws/compute/Registry',
  aws_ecs_container_instance: 'aws/compute/Container',
  aws_elasticache_memcached_cluster: 'aws/db/Memcached',
  aws_elasticache_redis_cluster: 'aws/db/Redis',
  aws_elasticache_cluster_node: 'aws/db/Cache',
  aws_elasticsearch_domain: 'aws/compute/SearchDocuments',
  aws_iam_access_key: 'aws/security/IAM',
  aws_iam_policy: 'aws/security/Permissions',
  aws_iam_account_password_policy: 'aws/manage/ChecklistSecurity',
  aws_iam_role: 'aws/security/Role',
  aws_iam_role_policy: 'aws/security/Permissions',
  aws_iam_group: 'aws/general/Users',
  aws_iam_group_policy: 'aws/security/Permissions',
  aws_iam_user: 'aws/general/User',
  aws_iam_user_policy: 'aws/security/Permissions',
  aws_kms_key: 'aws/security/DataEncryptionKey',
  aws_lambda_function: 'aws/compute/LambdaFunction',
  aws_s3_bucket: 'aws/storage/Bucket',
  aws_sns_subscription: 'aws/message/Worker',
  aws_sns_topic: 'aws/message/Topic',
  aws_sqs_queue: 'aws/message/Queue',
  aws_redshift_cluster: 'aws/compute/HDFSCluster',
  aws_rds_cluster: 'aws/compute/Cluster',
  aws_db_instance: 'aws/compute/DB',
  aws_alb: 'aws/compute/AppLoadBalancer',
  aws_nlb: 'aws/compute/LoadBalancer',
  aws_elb: 'aws/compute/LoadBalancer',
  aws_lb: 'aws/compute/LoadBalancer',
  aws_waf_web_acl: 'aws/manage/Permissions',

  // icons for atlassian resources/entities
  atlassian: 'brand/atlassian/logo',
  bitbucket_project: 'brand/aui/folder',
  bitbucket_repo: 'brand/aui/repository',
  bitbucket_team: 'brand/atlassian/bitbucket',
  bitbucket_user: 'brand/aui/person',
  bitbucket_pullrequest: 'brand/aui/pull-request',

  // icons for github resources/entities
  github: 'brand/octicons/logo-github',
  github_account: 'brand/octicons/mark-github',
  github_installation: 'brand/octicons/mark-github',
  github_repo: 'brand/octicons/repo',
  github_team: 'brand/octicons/jersey',
  github_user: 'brand/octicons/person',

  // icons for atlassian+jira resources/entities
  jira: 'brand/atlassian/jira',
  jira_account: 'brand/aui/person-circle',
  jira_issue: 'brand/aui/issue',
  jira_project: 'brand/aui/folder',
  jira_user: 'brand/aui/person',

  // icons for okta resources/entities
  okta: 'brand/okta/logo',
  okta_account: 'brand/okta/icon',

  // icons for SentinelOne resources/entities
  sentinelone: 'brand/sentinelone/icon',
};

export const importPathsByType: IIconMap = {
  aws: 'react-aws-icons/dist/aws',
  brand: '@jupiterone/react-brand-icons',
  feather: 'react-feather/dist/icons',
};
